import React, { useEffect } from "react";
import "./style.css";

function News(props) {
  const { content } = props.data;

  return (
    <div className="row main_body news">
      <div className="header_box">
        <a href="/news?type=1" className="btn" style={{ marginRight: "30px" }}>
          ニュース
        </a>
        /
        <a href="/news?type=2" className="btn" style={{ marginLeft: "30px" }}>
          情報
        </a>
      </div>

      <div className="posts_container">
        {content.map((val) => {
          return (
            <div className="card card-content" key={val.id}>
              <div className="info_box">
                <h6>{val.title}</h6>
                <p>Post at {val.created_at}</p>
                <br />
                <a href={`/new?id=${val.id}`} className="btn green darken-3">Read more</a>
              </div>
              <div className="img_box">
                    <img src={val.header_image} />
              </div>
            </div>
          );
        })}
      </div>
      
    </div>
  );
}
export default News;
